import {gql, useMutation} from "@apollo/client";
import SessionActionsList from "../../components/results/SessionActionsList";
import {MutationEducationSessionSubmitFeedbackArgs} from "../../schema";

const query = gql`
  query LMSChallengeEducationStateQuery($challengeId: ID!, $externalUserId: ID!) {
    state: getChallengeEducationState(challengeId: $challengeId, externalUserId: $externalUserId) {
      status
      canRetry
      bestAttempt {
        passed
        score
        time
        usedHints
        requestFeedback
        record
        recordState
        isContentMatches

        actionResults {
          __typename
          actionId
          branchId
          duration
          attempts
          isSkipped
          usedHint
          passed
        }
      }
      lastAttempt {
        sessionId
        feedbackText
        feedbackScore
      }
      attemptsCount
      passedAttemptsCount
      challengeId
    }

    account: getAccountByChallenge(challengeId: $challengeId) {
      id
      code
      name
    }

    user: getExternalUser(externalUserId: $externalUserId, challengeId: $challengeId) {
      id
      name
      fullName
      email
    }

    challenge: getChallenge(challengeId: $challengeId) {
      id
      mode
      avatar {
        name
      }
    }

    actions: getChallengeActions(challengeId: $challengeId) {
      id
      ...SessionActionsList
    }
  }

  ${SessionActionsList.fragments.root}
`;

export default query;

export const sendFeedbackMutation = gql`
  mutation PlayerSessionSubmitFeedback(
    $data: DetailedSessionFeedbackInput
    $score: Int
    $message: String
    $sessionId: ID!
  ) {
    result: educationSessionSubmitFeedback(data: $data, score: $score, message: $message, sessionId: $sessionId)
  }
`;

export function useSendFeedbackMutation() {
  return useMutation<{result: boolean}, MutationEducationSessionSubmitFeedbackArgs>(sendFeedbackMutation);
}
